import React from "react";
import { Flex } from "antd";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  DocumentStatus,
  documentStatusSelectItems,
  filteredDocumentStatusListByCurrentStatus,
} from "~/components/Forms/CreateDocument/utils/utils";
import { disabledFieldsByDocumentStatus } from "~/components/Forms/DocumentStatusForm/utils/utils";
import { Field } from "~/shared/ui/Field";

export interface IDocumentChangeStatusForm {
  status: DocumentStatus;
  canceledReason?: string;
}

interface IDocumentStatusFormProps {
  formId: string;
  cantEdit: boolean;
  defaultValues: IDocumentChangeStatusForm;
  onSubmitHandler: (data: IDocumentChangeStatusForm) => void;
}

const DocumentStatusForm = ({
  formId,
  cantEdit,
  defaultValues,
  onSubmitHandler,
}: IDocumentStatusFormProps) => {
  const { t } = useTranslation();

  const { control, handleSubmit, watch, errors } =
    useForm<IDocumentChangeStatusForm>({
      defaultValues,
    });

  const watchStatus = watch("status");

  const disabled =
    cantEdit || !!disabledFieldsByDocumentStatus(defaultValues.status);

  // Текущий статус всегда добавляем в опции, чтобы Select
  // корректно отображал значение, даже если оно недоступно для выбора
  const currentStatusOption = documentStatusSelectItems.find(
    (el) => el.value === defaultValues.status
  );
  const statusOptions = [
    ...(currentStatusOption ? [currentStatusOption] : []),
    ...(filteredDocumentStatusListByCurrentStatus(
      documentStatusSelectItems,
      defaultValues.status
    ) || []),
  ];

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmitHandler)}>
      <Flex vertical gap={10}>
        <Field
          type="select"
          name="status"
          control={control}
          label={t("documents.card.status")}
          options={statusOptions}
          rules={{ required: t("validation.required") }}
          error={errors["status"]?.message}
          disabled={disabled}
        />
        {watchStatus === DocumentStatus.Canceled && (
          <Field
            type="textarea"
            name="canceledReason"
            control={control}
            label={t("documents.canceledReason")}
            rules={{
              required: t("validation.required"),
              maxLength: { value: 250, message: t("validation.more250") },
            }}
            error={errors["canceledReason"]?.message}
            disabled={disabled}
          />
        )}
      </Flex>
    </form>
  );
};

export default DocumentStatusForm;
